module.exports = __webpack_public_path__ + "img/Trustor reward.661b77cb.svg";